/* eslint-disable */
import { getQuotasPart, getQuotaFieldsPart, getUserWorkingHoursPart } from '@vacationtracker/shared/graphql/shared-queries'

export const getLocations = /* GraphQL */ `
  query GetLocations {
    getLocationList {
      id
      name
      timestamp
      users {
        id
        name
        imageUrl
      }
      isDefault
      countryCode
      subdivisionCode
      holidays {
        year
        holidays {
          id
          multiDayId
        }
      }
      leavePolicies(onlyActive: true) {
        id
      }
    }
  }
`

// LOCATION_UPDATED carries the full membership and the handler moves anyone missing to the default
// location, so an inline field save has to send the list as it stands now - not the one the page
// rendered with, which lags every move made on the Users tab.
export const getLocationUserIds = /* GraphQL */ `
  query GetLocationUserIds($id: String!) {
    getLocation(id: $id) {
      id
      users {
        id
      }
    }
  }
`

export const getLocationPlaceById = /* GraphQL */ `
  query GetLocationPlaceById($id: String!) {
    getLocation(id: $id) {
      id
      name
      countryCode
      subdivisionCode
    }
  }
`

export const getLocationById = /* GraphQL */ `
  query GetLocationById($id: String!) {
    getLocation(id: $id) {
      id
      name
      timestamp
      users {
        id
        name
        imageUrl
      }
      isDefault
      workWeek
      workHours
      yearStartMonth
      yearStartDay
      firstDayOfWeek
      resetQuotas
      rolloverExpiryMonth
      rolloverExpiryDay
      rolloverExpiryAfterDays
      rolloverNeverExpireDays
      timezone
      countryCode
      subdivisionCode
      holidays {
        year
        holidays {
          id
          name
          date
          type
          multiDayId
          isHalfDay
          transferIfFallsOnNonWorkingDay
          transferOriginalDate
          recurring
          recurringId
          recurringRules {
            exactDate
            specificDaySet
            specificDayDuration
          }
        }
      }
    }
  }
`

export const getConnectedCalendars = /* GraphQL */ `
  query GetConnectedCalendar($userId: String!) {
    getConnectedGooogleCalendar(userId: $userId) {
      calendarId
      timezone
      type
      accessToken
      refreshToken
      error {
        code
      }
    }
    getConnectedOutlookCalendar(userId: $userId) {
      calendarId
      timezone
      type
      accessToken
      refreshToken
      error {
        code
      }
    }
  }
`

export const getOutOfOfficeSettings = /* GraphQL */ `
  query GetOutOfOfficeSettings {
    getOutOfOfficeSettings {
      oooPlatform
      snoozedLeaveTypes
      active
      refreshToken
      msTenantId
      googleUserId
      timezone
      outlookEmail
    }
  }
`

export const getUserNotificationPreferences = /* GraphQL */ `
  query GetUserNotificationPreferences {
    getUserNotificationPreferences {
      userId
      channelPreferences
      defaultChannel
    }
  }
`

export const getDataForOutOfOffice = /* GraphQL */ `
  query GetDataForOutOfOffice($leaveRequestId: String!) {
    getOutOfOfficeSettings {
      oooPlatform
      snoozedLeaveTypes
      active
      refreshToken
      msTenantId
      googleUserId
      timezone
      outlookEmail
    }
    getLeaveRequest(id: $leaveRequestId) {
      id
      user {
        id
        name
        imageUrl
        location {
          id
          name
        }
        team {
          id
          name
        }
      }
      status
      leavePolicyId
      leaveType {
        id
        name
      }
      startDate
      endDate
      isPartDay
      autoApproved
      partDayStartHour
      partDayEndHour
      partDay {
        startHour
        startMinute
        endHour
        endMinute
      }
      reason
      workingDays
      daysList {
        day
        leaveHours
        workingHoursInDay
      }
      calendarDays
      totalThisYear
      totalNextYear
      statusReason
      cancelledBeforeReview
      approver {
        id
        name
      }
      isEdited
      hasWorkingHoursSchedule
    }
  }
`

export const getLocationByIdLeaveTypesAllLeavePolicies = /* GraphQL */ `
  query GetLocationByIdLeaveTypesAllLeavePolicies($id: String!) {
    getLocation(id: $id) {
      id
      name
      timestamp
      countryCode
      subdivisionCode
      holidaysImportPlace {
        country
        state
      }
      users {
        id
        name
        imageUrl
        workWeekType
        workWeek
        workHours {${getUserWorkingHoursPart()}}
      }
      holidays {
        year
        holidays {
          id
          name
          date
          type
          multiDayId
          isHalfDay
          thirdPartyName
          thirdPartyLocale
          transferIfFallsOnNonWorkingDay
          transferOriginalDate
          recurring
          recurringId
          recurringRules {
            exactDate
            specificDaySet
            specificDayDuration
          }
        }
      }
      workWeek
      workHours
      yearStartMonth
      yearStartDay
      isDefault
      firstDayOfWeek
      resetQuotas
      rolloverExpiryMonth
      rolloverExpiryDay
      rolloverExpiryAfterDays
      rolloverNeverExpireDays
      timezone
      leavePolicies {
        id
        locationId
        isActive
        daysPerYear
        hoursPerYear
        maxRolloverDays
        maxRolloverHours
        quotaSetIn
        isApprovalRequired
        hasUnlimitedDays
        allowHalfDays
        shortestLeaveInterval
        hideLeaveType
        isReasonRequired
        negativeBallanceAllowed
        accrualType
        firstEarningDate
        accrualCapRate
        accrualPeriodStart
        accrualsLocked
        allowLeaveInPast
        broughtForwardExpirationSettings {
          enabled
          day
          month
          afterDays
        }
        negativeBroughtForwardAllowed
        enableRolloverExpiry
        rolloverExpiryMonth
        rolloverExpiryDay
        rolloverExpiryAfterDays
        allowAdvanceAccrualUsage
        pauseAccrualsWhenUserIsDeactivated
        toil
        toilShortestInterval
        toilRequestsAllowedForUsers
        toilExpiration
        toilExpirationDate
        toilExpirationMonths
        leaveType {
          id
          name
          isActive
          position
          deleted
        }
      }
    }
    getLeaveTypeList {
      id
      name
      isActive
      color
      position
    }
    getLocationList {
      id
      name
      isDefault
      leavePolicies {
        id
        locationId
        isActive
        daysPerYear
        hoursPerYear
        maxRolloverDays
        maxRolloverHours
        quotaSetIn
        allowLeaveInPast
        accrualCapRate
        isApprovalRequired
        hasUnlimitedDays
        allowHalfDays
        shortestLeaveInterval
        hideLeaveType
        isReasonRequired
        negativeBallanceAllowed
        accrualType
        firstEarningDate
        accrualPeriodStart
        enableRolloverExpiry
        rolloverExpiryMonth
        rolloverExpiryDay
        rolloverExpiryAfterDays
        broughtForwardExpirationSettings {
          enabled
          day
          month
          afterDays
        }
        negativeBroughtForwardAllowed
        allowAdvanceAccrualUsage
        pauseAccrualsWhenUserIsDeactivated
        toil
        toilShortestInterval
        toilRequestsAllowedForUsers
        toilExpiration
        toilExpirationDate
        toilExpirationMonths
        leaveType {
          id
          name
          isActive
          position
          deleted
        }
      }
    }
  }
`

export const getAllUserListShortPaginated = /* GraphQL */ `
  query GetAllUserListShortPaginated($limit: Int, $nextToken: String) {
    getAllUserListPaginated(limit: $limit, nextToken: $nextToken) {
      users {
        id
        name
        status
        email
      }
      nextToken
    }
  }
`

export const getAllUserListForMigrationPaginated = /* GraphQL */ `
  query GetAllUserListShortPaginated($limit: Int, $nextToken: String) {
    getAllUserListPaginated(limit: $limit, nextToken: $nextToken) {
      users {
        id
        name
        status
        email
        isAdmin
        initialUser
      }
      nextToken
    }
  }
`

const buildGetUsersFiltered = (energyPart: string) => /* GraphQL */ `
  query GetUsersFilteredCustom(
     $status: String!
     $name: String
     $locationIds: [String!]
     $teamIds: [String!]
     $labelIds: [String!]
     $inviteStatuses: [String!]
     $limit: Int = 200
     $nextToken: String
     $asc: Boolean = true
  ) {
    getUsersFiltered(
      status: $status
      name: $name
      locationIds: $locationIds
      teamIds: $teamIds
      labelIds: $labelIds
      inviteStatuses: $inviteStatuses
      limit: $limit
      nextToken: $nextToken
      asc: $asc
    ) {
      users {
        id
        name
        firstName
        lastName
        role
        roles
        isAdmin
        status
        startDate
        endDate
        email
        employeeId
        platform
        imageUrl
        isNameLocked
        timestamp
        birthday
        labels {
          id
          name
          color
        }
        location {
          id
          name
        }
        team {
          id
          name
        }
        isGhostUser
        adpIntegrated
        rechargeType
        rechargeTypeCompletedAt
        ${energyPart}
      }
      nextToken
      scannedCount
    }
  }
`

// The energy selection triggers extra DynamoDB reads in the resolver, so it is only
// requested when the team-energy feature is actually on for the viewer.
export const getUsersFiltered = buildGetUsersFiltered('energy { score mode }')
export const getUsersFilteredWithoutEnergy = buildGetUsersFiltered('')

export const getAllUsersSlim = /* GraphQL */ `
  query GetAllUsersSlim($status: String!, $limit: Int, $nextToken: String, $asc: Boolean = true) {
    getUsersFiltered(status: $status, locationIds: [], teamIds: [], labelIds: [], limit: $limit, nextToken: $nextToken, asc: $asc) {
      users {
        id
        name
        status
        email
        locationId
        teamId
      }
      nextToken
    }
  }
`

//this query is minimalized to only fetch the data needed for the import page
//be careful when changing this query, as it can cause db performance issues
export const getImportPageValidationData = /* GraphQL */ `
  query GetImportPageValidationData {
    getCompany {
      userEndDate
    }
    getTeamList {
      id
      name
      approvers {
        id
      }
    }
    getLeaveTypeList {
      id
      name
      isActive
    }
    getLocationList {
      id
      name
      workHours
      leavePolicies {
        id
        isReasonRequired
        isActive
        shortestLeaveInterval
        toil
        toilShortestInterval
      }
    }
    getWorkWeekList {
      companyId
      GroupIdStart
      startDate
      days
      workHours
      schedule {
        workHours
        startDate
      }
    }
  }
`

export const getTeams = /* GraphQL */ `
  query GetTeams {
    getTeamList {
      id
      name
      timestamp
      parentId
      users {
        id
        name
        imageUrl
      }
      approvers {
        id
        name
        imageUrl
      }
      isDefault
    }
  }
`

export const getTeamById = /* GraphQL */ `
  query GetTeamById($id: String!) {
    getTeam(id: $id) {
      id
      name
      timestamp
      parentId
      users {
        id
        name
        imageUrl
      }
      approvers {
        id
        name
        imageUrl
        approverLevels
      }
      isDefault
      watchersToNotify
      keepLeaveRequestsOpen
    }
  }
`

// If you do not have a nextToken, use the "NONE" value, as we need a value for cache eviction
export const getCalendarData = /* GraphQL */ `
  query GetCalendarData($dateStart: String!, $dateEnd: String!, $status: String!, $limit: Int!, $nextToken: String!) {
    getLeaveRequestByDate(dateStart: $dateStart, dateEnd: $dateEnd, status: $status, limit: $limit, nextToken: $nextToken) {
      nextToken
      leaveRequests {
        id
        user {
          id
          name
          locationId
          imageUrl
          teamId
          labels {
            id
            name
            color
          }
        }
        startDate
        endDate
        isPartDay
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        reason
        teamId
        locationId
        hasWorkingHoursSchedule
        leaveType {
          id
          isActive
          name
          color
          deleted
          position
          leavePolicies {
            locationId
            hideLeaveType
          }
        }
      }
    }
  }
`

// Query getLeaveRequestsByUsers we use only for wallchart on frontend
// This query call lambda function resolver-get-leave-request-by-user
// Before editing this query check rules in resolver-get-leave-request-by-user function
export const getCalendarInfo = /* GraphQL */ `
  query GetCalendarInfo($id: String!) {
    getUser(id: $id) {
      id
      workWeek
      approverTo {
        id
      }
    }
    getLocationListV2 {
      id
      name
      countryCode
      workWeek
      leavePolicies {
        hideLeaveType
        leaveType {
          id
          name
          isActive
          color
          deleted
          position
        }
      }
      timezone
      holidays {
        year
        holidays {
          name
          date
          multiDayId
          isHalfDay
        }
      }
    }
    getTeamListV2 {
      id
      name
      isDefault
      parentId
    }
    getLabelListV2 {
      id
      name
      color
    }
    getLeaveTypeList {
      id
      name
      isActive
      color
      position
    }
    getVisibilityAddon {
      visibilityLevel
    }
    getBlackoutPeriodForUser {
      id
      name
      startDate
      endDate
      recurring
      locations
      teams
      labels
    }
  }
`

export const getUsersForApprover = /* GraphQL */ `
  query GetUsersForApprover($id: String!) {
    getUser(id: $id) {
      id
      approverTo {
        id
        name
        role
      }
    }
  }
`

export const getDataForManageLicences = /* GraphQL */ `
  query GetDataForManageLicences($status: String!) {
    getUsersByStatus(status: $status) {
      id
      name
      isAdmin
      email
    }
    getCompany {
      id
      billing {
        quantity
      }
    }
  }
`

export const getUsersForAdminWithPagination = /* GraphQL */ `
  query GetUsersForAdminWithPagination($limit: Int = 500, $nextToken: String) {
    getActiveUsersWithPagination(limit: $limit, nextToken: $nextToken) {
      nextToken
      limit
      users {
        id
        name
        role
        locationId
      }
    }
  }
`

export const getSuggestedSubstituteApprovers = /* GraphQL */ `
  query getSuggestedSubstituteApprovers($limit: Int = 500, $nextToken: String, $upcomingLeavesDate: String) {
    getActiveUsersWithPagination(limit: $limit, nextToken: $nextToken) {
      nextToken
      limit
      users {
        id
        name
        role
        upcomingLeaves(date: $upcomingLeavesDate) {
          id
          status
          startDate
          endDate
          isPartDay
          hasWorkingHoursSchedule
          partDayStartHour
          partDayEndHour
          partDay {
            startHour
            startMinute
            endHour
            endMinute
          }
          leaveType {
            id
            name
          }
        }
        teamId
      }
    }
  }
`

export const getUserForLeaveRequest = /* GraphQL */ `
  query GetUserForLeaveRequest($id: String!) {
    getUser(id: $id) {
      id
      name
      locale
      role
      workHours {${getUserWorkingHoursPart()}}
      leaveDays {
        yearStart
        yearEnd
        userWorkingHours {${getUserWorkingHoursPart()}}
        leaveTypes {
          leavePolicyId
          leaveTypeId
          leaveTypeName
          isActive
          position
          color
          accrualType
          currentDays
          earnedDays
          earnedDaysWithoutRollover
          defaultDaysPerYear
          expiredDays
          hasUnlimitedDays
          rolloverFromPreviousYear
          usedDays
          seniorityEntitlementDaysForYear
          baseQuota
          toilDays
          toilDaysLapsed
          quota
          senioirtyEntitlementExists
          scheduledDays
          userLeaveTypeOverride
          ignoreRolloverFromPreviousYear
          allowHalfDays
          shortestLeaveInterval
          rolloverExpiryDate
          firstEarningDate
          accrualPeriodStart
          ${getQuotasPart()}
        }
      }
      location {
        id
        timezone
        yearStartDay
        yearStartMonth
        workWeek
        workHours
        holidays {
          year
          holidays {
            name
            date
            multiDayId
            isHalfDay
          }
        }
        leavePolicies(onlyActive: true) {
          id
          allowHalfDays
          shortestLeaveInterval
          isActive
          isReasonRequired
          maxRolloverDays
          hasUnlimitedDays
          accrualType
          firstEarningDate
          enableRolloverExpiry
          rolloverExpiryMonth
          rolloverExpiryDay
          rolloverExpiryAfterDays
          allowAdvanceAccrualUsage
          allowLeaveInPast
          broughtForwardExpirationSettings {
            enabled
            day
            month
            afterDays
          }
          toil
          toilRequestsAllowedForUsers
          toilShortestInterval
          leaveType {
            id
            name
            position
            deleted
            isActive
            calendarStatus
          }
        }
      }
      team {
        id
        name
        approvers {
          id
          name
        }
      }
    }
  }
`

export const getLeaveTypesForUser = /* GraphQL */ `
  query GetLeaveTypesForUser($id: String!) {
    getUser(id: $id) {
      id
      name
      locale
      hourFormat
      workHours {${getUserWorkingHoursPart()}}
      role
      team {
        id
        name
        approvers {
          id
          name
          approverLevels
        }
      }
      leaveDays {
        yearStart
        yearEnd
        userWorkingHours {${getUserWorkingHoursPart()}}
        leaveTypes {
          leavePolicyId
          leaveTypeId
          leaveTypeName
          isActive
          position
          color
          accrualType
          currentDays
          earnedDays
          earnedDaysWithoutRollover
          defaultDaysPerYear
          expiredDays
          hasUnlimitedDays
          rolloverFromPreviousYear
          usedDays
          seniorityEntitlementDaysForYear
          baseQuota
          toilDays
          toilDaysLapsed
          quota
          senioirtyEntitlementExists
          scheduledDays
          userLeaveTypeOverride
          ignoreRolloverFromPreviousYear
          allowHalfDays
          shortestLeaveInterval
          rolloverExpiryDate
          firstEarningDate
          accrualPeriodStart
          ${getQuotasPart()}
        }
      }
      location {
        id
        timezone
        yearStartDay
        holidays {
          year
          holidays {
            name
            date
            multiDayId
            isHalfDay
          }
        }
        leavePolicies {
          id
          name
          isActive
          allowHalfDays
          shortestLeaveInterval
          isReasonRequired
          allowLeaveInPast
          isApprovalRequired
          maxRolloverDays
          maxRolloverHours
          quotaSetIn
          toil
          toilRequestsAllowedForUsers
          toilShortestInterval
          allowAdvanceAccrualUsage
          leaveType {
            id
            name
            position
            deleted
            isActive
            calendarStatus
          }
        }
      }
    }
  }
`

export const getUserIdsForApprover = /* GraphQL */ `
  query GetUserIdsForApprover($id: String!) {
    getUser(id: $id) {
      id
      workWeek
      approverTo {
        id
      }
    }
  }
`

export const getUsersWithCustomLeaveQuota = /* GraphQL */ `
  query GetUsersWithCuseomLeaveQuota($leaveTypeId: String!, $locationId: String!) {
    getUsersWithCustomQuota(leaveTypeId: $leaveTypeId, locationId: $locationId) {
      users {
        id
        name
        locationId
      }
    }
  }
`

export const getCompanyInfo = /* GraphQL */ `
  query GetCompanyInfo {
    getCompany {
      id
      msTeamId
      msIsBotInstalled
      name
      organizationId
      contactEmail
      plan
      planBoost {
        status
        expiresAt
      }
      trialPeriod
      subscriptionStatus
      userEndDate
      platform
      importUsersAutomatically
      aiBotHelper
      announceNewUsers
      hourlyLeaveAccounting
      timestamp
      calculationStartYear
      shouldProrate
      proratedLeaveTypes
      defaultDepartmentForAutomaticImport
      defaultLocationForAutomaticImport
      featurePermissions {
        featureVisibility {
          wallchartAccess
          reportsAccess
          energyLevelAccess
          employeeRecordsVisibility
          teamEnergyAccess
          veeEnabled
        }
        communication {
          quarterlyInsightsRecipients
        }
        betaFeatures {
          slackAiAgent
        }
      }
      billing {
        stripeCurrentPeriodEnd
        paymentProcessor
        subscriptionPeriod
        subscriptionPlan
        nextSubscriptionPeriod
        nextSubscriptionPlan
        address {
          city
          country
          state
          address
          addressLine2
        }
        quantity
        paymentMethodAdded
        msPlanId
        msSubscriptionStatus
        msPeriodEndDate
        msPeriodStartDate
        couponCodes
        billingName
        billingEmails
        stripePriceId
        billingType
        seats
        defaultCurrency
      }
    }
  }
`

export const getCompanyGeneral = /* GraphQL */ `
  query GetCompanyGeneral {
    getCompany {
      id
      name
      importUsersAutomatically
      aiBotHelper
      announceNewUsers
      hourlyLeaveAccounting
      userEndDate
      platform
      shouldProrate
      proratedLeaveTypes
      defaultDepartmentForAutomaticImport
      defaultLocationForAutomaticImport
      calculationStartYear
      contactEmail
      shouldImportGuestUsers
      isLegacyPlanCustomer
      featurePermissions {
        featureVisibility {
          wallchartAccess
          reportsAccess
          energyLevelAccess
          employeeRecordsVisibility
          teamEnergyAccess
          veeEnabled
        }
        communication {
          quarterlyInsightsRecipients
        }
        betaFeatures {
          slackAiAgent
        }
      }
      integrationOnboardings {
        name
        completedPercentage
      }
    }
    getWorkWeekList {
      companyId
      GroupIdStart
      startDate
      days
      workHours
      schedule {
        workHours
        startDate
      }
    }
  }
`

export const getCompanyAndUserInfo = /* GraphQL */ `
  query GetCompanyAndUserInfo($userId: String!) {
    getCompany {
      id
      msTeamId
      msIsBotInstalled
      name
      organizationId
      contactEmail
      plan
      planBoost {
        status
        expiresAt
      }
      trialPeriod
      subscriptionStatus
      userEndDate
      platform
      importUsersAutomatically
      aiBotHelper
      announceNewUsers
      hourlyLeaveAccounting
      timestamp
      calculationStartYear
      shouldProrate
      proratedLeaveTypes
      defaultDepartmentForAutomaticImport
      defaultLocationForAutomaticImport
      billing {
        stripeCurrentPeriodEnd
        paymentProcessor
        subscriptionPeriod
        subscriptionPlan
        nextSubscriptionPeriod
        nextSubscriptionPlan
        address {
          city
          country
          state
          address
          addressLine2
        }
        quantity
        paymentMethodAdded
        msPlanId
        msSubscriptionStatus
        msPeriodEndDate
        msPeriodStartDate
        couponCodes
        billingName
        billingEmails
        stripePriceId
        billingType
        seats
        defaultCurrency
      }
      companyMigrated
      isLegacyPlanCustomer
      toilEnabled
      featurePermissions {
        featureVisibility {
          wallchartAccess
          reportsAccess
          energyLevelAccess
          employeeRecordsVisibility
          teamEnergyAccess
          veeEnabled
        }
        communication {
          quarterlyInsightsRecipients
        }
        betaFeatures {
          slackAiAgent
        }
      }
      integrationOnboardings {
        name
        completedPercentage
      }
    }
    getUser(id: $userId) {
      id
      name
      role
      roles
      roleAssignments {
        roleId
        scope {
          type
          resourceIds
        }
      }
      initialUser
      startDate
      email
      platform
      imageUrl
      workWeek
      workWeekType
      isNameLocked
      locale
      hourFormat
      hasSeenApproverOnboarding
      rechargeType
      rechargeTypeCompletedAt
      rechargeTypeQuizAnswers {
        q1
        q2
        q3
      }
      birthday
      announcementMyBirthday
      teamEnergyOptedOut
      location {
        id
        name
        timezone
        countryCode
        subdivisionCode
        workWeek
        yearStartDay
        yearStartMonth
        firstDayOfWeek
        isDefault
        resetQuotas
        leavePolicies {
          toil
          id
          toilRequestsAllowedForUsers
          negativeBallanceAllowed
          isActive
          locationId
          daysPerYear
          hoursPerYear
          quotaSetIn
          maxRolloverDays
          maxRolloverHours
          hasUnlimitedDays
          shortestLeaveInterval
          hideLeaveType
          accrualType
          isApprovalRequired
          isReasonRequired
          allowLeaveInPast
          broughtForwardExpirationSettings {
            enabled
          }
          allowAdvanceAccrualUsage
          leaveType {
            name
            color
            id
            isActive
          }
        }
      }
      team {
        id
        name
        approvers {
          id
          name
          imageUrl
          approverLevels
        }
        users {
          id
          name
          imageUrl
        }
      }
      status
      approverTo {
        id
      }
      approverToTeams {
        id
        name
      }
    }
  }
`

export const getWorkWeekList = /* GraphQL */ `
  query GetWorkWeekList {
    getWorkWeekList {
      companyId
      GroupIdStart
      startDate
      days
      workHours
      schedule {
        workHours
        startDate
      }
    }
  }
`

export const getCompanyBillingInfo = /* GraphQL */ `
  query GetCompanyBillingInfo {
    getCompany {
      id
      plan
      trialPeriod
      numberOfActiveUsers
      timestamp
      billing {
        paymentProcessor
        paymentProcessorId
        billingName
        billingEmails
        address {
          city
          country
          state
          address
          addressLine2
        }
        stripeCustomerId
        stripePaymentMethodId
        stripeSubscriptionId
        stripeSubscriptionItemId
        stripePriceId
        stripeCurrentPeriodEnd
        stripePaymentStatus
        sendInvoice
        paymentMethodAdded
        subscriptionPeriod
        subscriptionPlan
        nextSubscriptionPlan
        nextSubscriptionPeriod
        subscriptionStatus
        msSubscriptionId
        quantity
        msPlanId
        msSubscriptionStatus
        msPeriodStartDate
        msPeriodEndDate
        billingType
        seats
        defaultCurrency
      }
    }
    getTeamList {
      id
      name
      isDefault
      parentId
      approvers {
        id
        approverLevels
      }
      watchersToNotify
    }
    getLocationList {
      id
      name
      workHours
      isDefault
    }
    getLeaveTypeList {
      id
      name
      isActive
      color
    }
    getAutomationProbationPeriods {
      id
      name
      isActive
    }
    getAddonsSubscription {
      automations {
        type
        status
      }
      addons {
        type
        status
      }
    }
  }
`

export const getCompanyBillingInfoForDowngrade = /* GraphQL */ `
  query GetCompanyBillingInfoForDowngrade {
    getCompany {
      id
      plan
      trialPeriod
      numberOfActiveUsers
      timestamp
      billing {
        paymentProcessor
        paymentProcessorId
        billingName
        billingEmails
        address {
          city
          country
          state
          address
          addressLine2
        }
        stripeCustomerId
        stripePaymentMethodId
        stripeSubscriptionId
        stripeSubscriptionItemId
        stripePriceId
        stripeCurrentPeriodEnd
        stripePaymentStatus
        sendInvoice
        paymentMethodAdded
        subscriptionPeriod
        subscriptionPlan
        nextSubscriptionPlan
        nextSubscriptionPeriod
        subscriptionStatus
        msSubscriptionId
        quantity
        msPlanId
        msSubscriptionStatus
        msPeriodStartDate
        msPeriodEndDate
        billingType
        seats
        defaultCurrency
      }
    }
    getTeamList {
      id
      name
      isDefault
      parentId
      approvers {
        id
        approverLevels
      }
      watchersToNotify
    }
    getLocationList {
      id
      name
      isDefault
      leavePolicies {
        id
        isActive
        leaveType {
          id
          name
          isActive
          deleted
          position
        }
      }
    }
    getLeaveTypeList {
      id
      name
      isActive
      color
      position
    }
    getAutomationProbationPeriods {
      id
      name
      isActive
    }
    getAddonsSubscription {
      automations {
        type
        status
      }
      addons {
        type
        status
      }
    }
  }
`

export const getNumberOfActiveUsers = /* GraphQL */ `
  query GetCompanyBillingInfo {
    getCompany {
      numberOfActiveUsers
    }
  }
`

export const getCompanyLogs = /* GraphQL */ `
  query GetCompanyLogs($fromDate: String!, $toDate: String!, $eventGroup: String, $groupKey: String, $lastId: String) {
    getCompany {
      logs(fromDate: $fromDate, toDate: $toDate, eventGroup: $eventGroup, groupKey: $groupKey, lastId: $lastId) {
        sk
        type
        timestamp
        creatorName
        creatorId
        paramsJson
      }
    }
  }
`

export const getLeaveRequestData = /* GraphQL */ `
  query GetLeaveRequestData($leaveRequestId: String!) {
    getLeaveRequest(id: $leaveRequestId) {
      id
      userId
      user {
        locationId
      }
      status
      leavePolicyId
      calendarStatus
      leaveType {
        id
        name
        calendarStatus
        leavePolicies {
          shortestLeaveInterval
          isReasonRequired
          locationId
          allowLeaveInPast
        }
      }
      autoApproved
      startDate
      endDate
      isPartDay
      partDayStartHour
      partDayEndHour
      partDay {
        startHour
        startMinute
        endHour
        endMinute
      }
      reason
      workingDays
      hasWorkingHoursSchedule
      daysList {
        day
        leaveHours
        workingHoursInDay
      }
      substituteApproverId
    }
  }
`

export const getLeaveRequestByIdForSubscription = /* GraphQL */ `
  query GetLeaveRequestById(
    $leaveRequestId: String!
  ) {
    getLeaveRequest(id: $leaveRequestId) {
      id
      user {
        id
        companyId
        name
        team {
          id
          name
          approvers {
            id
            name
            approverLevels
          }
        }
        leaveDays {
          yearStart
          yearEnd
          userWorkingHours {${getUserWorkingHoursPart()}}
          leaveTypes {
            leaveTypeId
            leaveTypeName
            leavePolicyId
            accrualType
            currentDays
            earnedDays
            earnedDaysWithoutRollover
            defaultDaysPerYear
            expiredDays
            hasUnlimitedDays
            rolloverFromPreviousYear
            usedDays
            userLeaveTypeOverride
            position
            color
            isActive
            ignoreRolloverFromPreviousYear
            shouldProrate
            userProratedLeaveTypes
            ${getQuotasPart()}
          }
        }
      }
      status
      leavePolicyId
      leaveType {
        id
        name
      }
      startDate
      endDate
      isPartDay
      autoApproved
      partDayStartHour
      partDayEndHour
      partDay {
        startHour
        startMinute
        endHour
        endMinute
      }
      reason
      workingDays
      hasWorkingHoursSchedule
      daysList {
        day
        leaveHours
        workingHoursInDay
      }
      calendarDays
      totalThisYear
      totalNextYear
      statusReason
      cancelledBeforeReview
      approvedLevel
      approver {
        id
        name
      }
      isEdited
    }
  }
`

export const getToilRequestByIdForSubscription = /* GraphQL */ `
  query GetToilRequestById($toilRequestId: String!) {
    getToilRequest(id: $toilRequestId) {
      id
      user {
        id
        companyId
        name
        team {
          id
          name
          approvers {
            id
            name
          }
        }
      }
      status
      leaveType {
        id
        name
      }
      leavePolicyId
      startDate
      endDate
      isPartDay
      partDayStartHour
      partDayEndHour
      partDay {
        startHour
        startMinute
        endHour
        endMinute
      }
      reason
      statusReason
      approver {
        id
        name
      }
    }
  }
`

export const getUserForLeaveRequestUpdateNotification = /* GraphQL */ `
  query getUserForUpdate($id: String!) {
    getUser(id: $id) {
      id
      name
      workHours {${getUserWorkingHoursPart()}}
    }
  }
`

export const getLeaveRequestById = /* GraphQL */ `
  query GetLeaveRequestById($leaveRequestId: String!) {
    getLeaveRequest(id: $leaveRequestId) {
      id
      user {
        id
        name
        imageUrl
        workHours {${getUserWorkingHoursPart()}}
        location {
          id
          name
        }
        team {
          id
          name
          approvers {
            id
            name
            approverLevels
          }
        }
        leaveDays {
          yearStart
          yearEnd
          userWorkingHours {${getUserWorkingHoursPart()}}
          leaveTypes {
            leaveTypeId
            leaveTypeName
            leavePolicyId
            accrualType
            currentDays
            earnedDays
            earnedDaysWithoutRollover
            defaultDaysPerYear
            expiredDays
            hasUnlimitedDays
            rolloverFromPreviousYear
            usedDays
            userLeaveTypeOverride
            position
            color
            isActive
            ignoreRolloverFromPreviousYear
            shouldProrate
            userProratedLeaveTypes
            ${getQuotasPart()}
          }
        }
      }
      status
      leavePolicyId
      leaveType {
        id
        name
      }
      startDate
      endDate
      isPartDay
      autoApproved
      partDayStartHour
      partDayEndHour
      partDay {
        startHour
        startMinute
        endHour
        endMinute
      }
      reason
      workingDays
      hasWorkingHoursSchedule
      daysList {
        day
        leaveHours
        workingHoursInDay
      }
      calendarDays
      totalThisYear
      totalNextYear
      statusReason
      cancelledBeforeReview
      approver {
        id
        name
      }
      approvedLevel
      isEdited
    }
  }
`

export const getToilRequestById = /* GraphQL */ `
  query GetToilRequestById($leaveRequestId: String!) {
    getToilRequest(id: $leaveRequestId) {
      id
      user {
        id
        name
        imageUrl
        location {
          id
          name
        }
        team {
          id
          name
        }
        leaveDays {
          yearStart
          yearEnd
          userWorkingHours {${getUserWorkingHoursPart()}}
          leaveTypes {
            leaveTypeId
            leaveTypeName
            leavePolicyId
            accrualType
            currentDays
            earnedDays
            earnedDaysWithoutRollover
            defaultDaysPerYear
            expiredDays
            hasUnlimitedDays
            rolloverFromPreviousYear
            usedDays
            userLeaveTypeOverride
            position
            color
            isActive
            ignoreRolloverFromPreviousYear
            shouldProrate
            userProratedLeaveTypes
            ${getQuotasPart()}
          }
        }
      }
      status
      leavePolicyId
      leaveType {
        id
        name
      }
      startDate
      endDate
      daysList
      isPartDay
      partDayStartHour
      partDayEndHour
      partDay {
        startHour
        startMinute
        endHour
        endMinute
      }
      reason
      statusReason
      approver {
        id
        name
      }
    }
  }
`

export const getUserHolidays = /* GraphQL */ `
  query GetUserHolidays($id: String!) {
    getUser(id: $id) {
      id
      location {
        id
        name
        workWeek
        firstDayOfWeek
        holidays {
          year
          holidays {
            name
            date
            multiDayId
            isHalfDay
          }
        }
      }
    }
  }
`

export const getUserById = /* GraphQL */ `
  query GetUserById(
    $id: String!,
    $date: String,
    $pendingLeavesDate: String,
  ) {
    getUser(id: $id) {
      id
      name
      firstName
      lastName
      role
      isAdmin
      status
      startDate
      endDate
      employeeId
      birthday
      email
      platform
      imageUrl
      isNameLocked
      workWeek
      workWeekType
      workWeekInfo
      workHours {${getUserWorkingHoursPart()}}
      timestamp
      imageUrl
      locale
      hourFormat
      isGhostUser
      adpIntegrated
      rechargeType
      rechargeTypeCompletedAt
      rechargeTypeQuizAnswers {
        q1
        q2
        q3
      }
      roles
      roleAssignments {
        roleId
        scope {
          type
          resourceIds
        }
      }
      location {
        id
        name
        workWeek
        firstDayOfWeek
        resetQuotas
        rolloverNeverExpireDays
        rolloverExpiryMonth
        rolloverExpiryDay
        rolloverExpiryAfterDays
        yearStartDay
        yearStartMonth
        timezone
        leavePolicies {
          id
          name
          allowHalfDays
          shortestLeaveInterval
          isActive
          isReasonRequired
          allowLeaveInPast
          toil
          toilShortestInterval
          toilRequestsAllowedForUsers
          allowAdvanceAccrualUsage
          maxRolloverDays
          maxRolloverHours
          quotaSetIn
          hasUnlimitedDays
          accrualType
          firstEarningDate
          accrualPeriodStart
          enableRolloverExpiry
          rolloverExpiryMonth
          rolloverExpiryDay
          rolloverExpiryAfterDays
          broughtForwardExpirationSettings {
            enabled
            day
            month
            afterDays
          }
          leaveType {
            id
            name
            position
            deleted
            isActive
            calendarStatus
          }
        }
      }
      team {
        id
        name
        approvers {
          id
          name
          approverLevels
        }
      }
      leaveDays {
        yearStart
        yearEnd
        userWorkingHours {${getUserWorkingHoursPart()}}
        leaveTypes {
          leavePolicyId
          leaveTypeId
          leaveTypeName
          isActive
          position
          color
          accrualType
          currentDays
          earnedDays
          earnedDaysWithoutRollover
          defaultDaysPerYear
          seniorityEntitlementDaysForYear
          entitlementByRoleDaysForYear
          senioirtyEntitlementExists
          entitlementByRoleExists
          baseQuota
          quota
          toilDays
          toilDaysLapsed
          capHit
          expiredDays
          hasUnlimitedDays
          rolloverFromPreviousYear
          usedDays
          scheduledDays
          userLeaveTypeOverride
          ignoreRolloverFromPreviousYear
          allowHalfDays
          shortestLeaveInterval
          rolloverExpiryDate
          shouldProrate
          userProratedLeaveTypes
          pauseAccrualsWhenUserIsDeactivated
          ${getQuotasPart()}
        }
      }
      upcomingLeaves(date: $date) {
        id
        status
        user {
          id
        }
        leavePolicyId
        approver {
          id
          name
        }
        approverList {
          id
          name
        }
        leaveType {
          name
        }
        autoApproved
        startDate
        endDate
        isPartDay
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        reason
        statusReason
        workingDays
        hasWorkingHoursSchedule
        daysList {
          day
          leaveHours
          workingHoursInDay
        }
        isEdited
        approvedBySubstituteApprover
        reviewedThroughIntegration
      }
      pendingLeaves(date: $pendingLeavesDate) {
        id
        status
        startDate
        endDate
        isPartDay
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        leaveType {
          id
          name
        }
        autoApproved
        reason
        workingDays
        hasWorkingHoursSchedule
        daysList {
          day
          leaveHours
          workingHoursInDay
        }
        totalThisYear
        totalNextYear
        isEdited
        approvedBySubstituteApprover
        approvedLevel
      }
      history(date: $date) {
        id
        status
        user {
          id
        }
        leaveType {
          id
          name
          color
        }
        leavePolicy {
          allowLeaveInPast
          isReasonRequired
        }
        approver {
          id
          name
        }
        approverList {
          id
          name
        }
        autoApproved
        startDate
        endDate
        isPartDay
        isResent
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        reason
        statusReason
        workingDays
        hasWorkingHoursSchedule
        daysList {
          day
          leaveHours
          workingHoursInDay
        }
        cancelledBeforeReview
        isEdited
        approvedBySubstituteApprover
        reviewedThroughIntegration
      }
      today(date: $date) {
        id
        startDate
        endDate
        isPartDay
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        reason
        workingDays
        hasWorkingHoursSchedule
        daysList {
          day
          leaveHours
          workingHoursInDay
        }
        autoApproved
        approver {
          id
          name
        }
        approverList {
          id
          name
        }
        leaveType {
          id
          name
          color
        }
        statusReason
        approvedBySubstituteApprover
        reviewedThroughIntegration
      }
      labels {
        id
        name
        color
      }
      probationPeriod {
        lengthDays
        name
        leaveTypeIds
      }
    }
    getCompany {
      userEndDate
    }
    getTeamListV2 {
      id
      name
      isDefault
      parentId
    }
    getLocationListV2 {
      id
      name
    }
    getLabelListV2 {
      id
      name
      color
      userCount
    }
  }
`

export const getUserLogs = /* GraphQL */ `
  query GetUserLogs($id: String!, $fromDate: String!, $toDate: String!) {
    getUser(id: $id) {
      id
      logs(fromDate: $fromDate, toDate: $toDate) {
        type
        timestamp
        creatorName
        creatorId
        paramsJson
      }
    }
  }
`

export const getCurrentUser = /* GraphQL */ `
  query GetCurrentUser(
    $id: String!,
    $date: String,
    $pendingLeavesDate: String,
  ) {
    getUser(id: $id) {
      id
      name
      firstName
      lastName
      role
      isAdmin
      email
      status
      startDate
      endDate
      employeeId,
      platform
      imageUrl
      birthday
      workWeek
      workWeekType
      workWeekInfo
      workHours {${getUserWorkingHoursPart()}}
      timestamp
      locale
      hourFormat
      rechargeType
      rechargeTypeCompletedAt
      rechargeTypeQuizAnswers {
        q1
        q2
        q3
      }
      labels {
        id
        name
        color
      }
      location {
        id
        name
        workWeek
        firstDayOfWeek
        resetQuotas
        rolloverNeverExpireDays
        rolloverExpiryMonth
        rolloverExpiryDay
        rolloverExpiryAfterDays
        yearStartDay
        timezone
        leavePolicies {
          id
          name
          allowHalfDays
          accrualPeriodStart
          shortestLeaveInterval
          isActive
          isReasonRequired
          maxRolloverDays
          hasUnlimitedDays
          accrualType
          firstEarningDate
          enableRolloverExpiry
          rolloverExpiryMonth
          rolloverExpiryDay
          rolloverExpiryAfterDays
          broughtForwardExpirationSettings {
            enabled
            day
            month
            afterDays
          }
          toil
          toilRequestsAllowedForUsers
          toilShortestInterval
          leaveType {
            id
            name
            position
            deleted
            isActive
          }
        }
        holidays {
          year
          holidays {
            name
            date
            isHalfDay
          }
        }
      }
      team {
        id
        name
        approvers {
          id
          name
        }
      }
      leaveDays {
        yearStart
        yearEnd
        userWorkingHours {${getUserWorkingHoursPart()}}
        leaveTypes {
          leavePolicyId
          leaveTypeId
          leaveTypeName
          isActive
          position
          color
          accrualType
          currentDays
          earnedDays
          earnedDaysWithoutRollover
          seniorityEntitlementDaysForYear
          senioirtyEntitlementExists
          baseQuota
          toilDays
          toilDaysLapsed
          quota
          defaultDaysPerYear
          expiredDays
          hasUnlimitedDays
          rolloverFromPreviousYear
          usedDays
          scheduledDays
          userLeaveTypeOverride
          ignoreRolloverFromPreviousYear
          allowHalfDays
          shortestLeaveInterval
          rolloverExpiryDate
          shouldProrate
          userProratedLeaveTypes
          pauseAccrualsWhenUserIsDeactivated
          firstEarningDate
          accrualPeriodStart
          ${getQuotasPart()}
        }
      }
      upcomingLeaves(date: $date) {
        id
        status
        user {
          id
        }
        leavePolicyId
        approver {
          id
          name
        }
        leaveType {
          name
        }
        autoApproved
        startDate
        endDate
        isPartDay
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        reason
        statusReason
        workingDays
        hasWorkingHoursSchedule
        daysList {
          day
          leaveHours
          workingHoursInDay
        }
        approvedBySubstituteApprover
        reviewedThroughIntegration
        isEdited
      }
      pendingLeaves(date: $pendingLeavesDate) {
        id
        status
        startDate
        endDate
        isPartDay
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        leaveType {
          id
          name
        }
        autoApproved
        reason
        workingDays
        hasWorkingHoursSchedule
        daysList {
          day
          leaveHours
          workingHoursInDay
        }
        totalThisYear
        totalNextYear
        isEdited
        approvedLevel
      }
      history(date: $date) {
        id
        status
        user {
          id
        }
        leaveType {
          id
          name
          color
        }
        leavePolicy {
          allowLeaveInPast
          isReasonRequired
        }
        approver {
          id
          name
        }
        autoApproved
        startDate
        endDate
        isPartDay
        isResent
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        reason
        statusReason
        workingDays
        hasWorkingHoursSchedule
        daysList {
          day
          leaveHours
          workingHoursInDay
        }
        cancelledBeforeReview
        approvedBySubstituteApprover
        reviewedThroughIntegration
        isEdited
      }
      today(date: $date) {
        id
        startDate
        endDate
        isPartDay
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        reason
        workingDays
        hasWorkingHoursSchedule
        daysList {
          day
          leaveHours
          workingHoursInDay
        }
        approver {
          id
          name
        }
        autoApproved
        leaveType {
          id
          name
          color
        }
        statusReason
        approvedBySubstituteApprover
        reviewedThroughIntegration
      }
      probationPeriod {
        lengthDays
        name
        leaveTypeIds
      }
    }
    getLabels {
      id
      name
      color
    }
    getCompany {
      userEndDate
    }
    getVisibilityAddon {
      visibilityLevel
    }
  }
`

// If you do not have a nextToken, use the "NONE" value, as we need a value for cache eviction
export const getLeavesByDateAndStatus = /* GraphQL */ `
  query GetLeavesByDateAndStatus($dateStart: String!, $dateEnd: String!, $status: String!, $limit: Int!, $nextToken: String!) {
    getLeaveRequestByDate(dateStart: $dateStart, dateEnd: $dateEnd, status: $status, limit: $limit, nextToken: $nextToken) {
      leaveRequests {
        id
        user {
          id
          name
          imageUrl
          team {
            id
            name
            approvers {
              id
              approverLevels
            }
          }
          labels {
            id
            name
            color
          }
          location {
            id
            name
          }
        }
        status
        approver {
          id
          name
        }
        approverList {
          id
          name
        }
        leavePolicy {
          id
          hideLeaveType
          leaveType {
            id
            name
            color
            deleted
          }
        }
        autoApproved
        startDate
        endDate
        isPartDay
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        reason
        workingDays
        hasWorkingHoursSchedule
        calendarDays
        daysList {
          day
          leaveHours
          workingHoursInDay
        }
        totalThisYear
        totalNextYear
        substituteApproverId
        approvedBySubstituteApprover
        reviewedThroughIntegration
        isEdited
      }
      nextToken
    }
  }
`

export const getToilByDateAndStatus = /* GraphQL */ `
  query GetToilByDateAndStatus($dateStart: String!, $dateEnd: String!, $status: String!, $limit: Int!, $nextToken: String!) {
    getToilRequestsByDate(dateStart: $dateStart, dateEnd: $dateEnd, status: $status, limit: $limit, nextToken: $nextToken) {
      toilRequests {
        id
        user {
          id
          name
          imageUrl
          team {
            id
            approvers {
              id
            }
          }
          labels {
            id
            name
            color
          }
          location {
            id
            name
          }
        }
        status
        approver {
          id
          name
        }
        leavePolicy {
          id
          hideLeaveType
          leaveType {
            id
            name
            color
            deleted
          }
        }
        daysList
        startDate
        endDate
        isPartDay
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        reason
      }
      nextToken
    }
  }
`

export const getHeatmapData = /* GraphQL */ `
  query GetHeatmapData {
    locations: getLocationListV2 {
      name
      id
      countryCode
      users {
        id
      }
      holidays {
        year
        holidays {
          name
          date
          isHalfDay
        }
      }
    }
    departments: getTeamListV2 {
      id
      name
      parentId
      users {
        id
      }
    }
    labels: getLabelListV2 {
      id
      name
      color
    }
  }
`

export const getCompanyNotificationsV2 = /* GraphQL */ `
  query GetCompanyNotificationsV2 {
    getNotificationsV2 {
      id
      name
      firstDayOfWeek
      frequency
      destinations {
        platform
        addresses
        msGroup
        channelName
      }
      sendOnNonWorkingDays
      day
      hour
      minute
      timezone
      enabled
      locations
      teams
      labels
      groupBy
      sendEmpty
      currentWeek
      sendOnDays
      locale
      error
      owner {
        id
        name
      }
    }
  }
`

export const getNotificationById = /* GraphQL */ `
  query getNotificationById($id: String!) {
    getNotification(id: $id) {
      id
      name
      firstDayOfWeek
      frequency
      destinations {
        platform
        addresses
        msGroup
        channelName
      }
      day
      hour
      minute
      timezone
      enabled
      locations
      teams
      labels
      groupBy
      sendEmpty
      currentWeek
      sendOnDays
      locale
      error
      managersReminders
      sendOnNonWorkingDays
      owner {
        id
        name
      }
    }
  }
`

export const errorSubscription = /* GraphQL */ `
  subscription GetErrors($userId: String!) {
    eventResponses(userId: $userId) {
      companyId
      userId
      correlationId
      code
      errorCode
      data
      message
      originalEvent
      result
      name
    }
  }
`

export const companyUpdateSubscription = /* GraphQL */ `
  subscription GetCompanyUpdates($companyId: String!) {
    companyUpdates(companyId: $companyId) {
      companyId
      userId
      correlationId
      code
      message
      originalEvent
      result
    }
  }
`

export const whatsNewResponseSubscription = /* GraphQL */ `
  subscription GetWhatsNewResponse($userId: String!) {
    whatsNewResponse(userId: $userId) {
      companyId
      userId
      messageId
      originalEvent
    }
  }
`

export const getPendingForApproverById = /* GraphQL */ `
  query GetPendingForApproverById {
    getPendingForApprover {
      id
      user {
        id
        name
        imageUrl
        team {
          id
          name
          approvers {
            id
            approverLevels
          }
        }
        labels {
          id
          name
          color
        }
        location {
          id
          name
        }
      }
      status
      approvedLevel
      approver {
        id
        name
      }
      approverList {
        id
        name
      }
      leavePolicy {
        id
        hideLeaveType
        leaveType {
          id
          name
          color
          deleted
        }
      }
      startDate
      endDate
      isPartDay
      partDayStartHour
      partDayEndHour
      partDay {
        startHour
        startMinute
        endHour
        endMinute
      }
      reason
      workingDays
      hasWorkingHoursSchedule
      daysList {
        day
        leaveHours
        workingHoursInDay
      }
      calendarDays
      totalThisYear
      totalNextYear
      created
      isEdited
      editedBy {
        id
        name
        imageUrl
      }
    }
    getPendingToilForApprover {
      id
      user {
        id
        name
        imageUrl
        team {
          id
          name
          approvers {
            id
          }
        }
        labels {
          id
          name
          color
        }
        location {
          id
          name
        }
      }
      status
      approver {
        id
        name
      }
      leavePolicy {
        id
        hideLeaveType
        leaveType {
          id
          name
          color
          deleted
        }
      }
      daysList
      startDate
      endDate
      isPartDay
      partDayStartHour
      partDayEndHour
      partDay {
        startHour
        startMinute
        endHour
        endMinute
      }
      reason
      created
    }
  }
`

// Slim per-user balance read for the dashboard leave cards/drawer: same resolver the request
// form uses (one user's quota calculation per call), fetched lazily and cached client-side so
// the pending-for-approver lambda is never asked to compute balances in bulk.
export const getUserLeaveBalance = /* GraphQL */ `
  query GetUserLeaveBalance($id: String!) {
    getUser(id: $id) {
      id
      leaveDays {
        yearStart
        yearEnd
        leaveTypes {
          leaveTypeId
          hasUnlimitedDays
          accrualType
          quotas {
            remaining {
              days
              hours
              minutes
              isNegative
              raw {
                days
                hours
              }
            }
          }
        }
      }
      location {
        id
        leavePolicies {
          allowAdvanceAccrualUsage
          leaveType {
            id
          }
        }
      }
    }
  }
`

export const getLocationsAndTeamsShort = /* GraphQL */ `
  query GetLocationsAndTeamsShort {
    getLocationList {
      id
      name
    }
    getTeamList {
      id
      name
    }
  }
`

export const getLocationsTeamsAndLabelsShort = /* GraphQL */ `
  query GetLocationsTeamsAndLabelsShort {
    getLocationListV2 {
      id
      name
      countryCode
    }
    getTeamListV2 {
      id
      name
      parentId
    }
    getLabelListV2 {
      id
      name
      color
    }
  }
`

export const getAutomationFormData = /* GraphQL */ `
  query GetAutomationFormData {
    getLocationList {
      id
      name
      countryCode
      resetQuotas
      yearStartMonth
      yearStartDay
    }
    getTeamList {
      id
      name
      parentId
    }
    getLabels {
      id
      name
      color
    }
    getLeaveTypeList {
      id
      name
      position
      isActive
      color
    }
    getAutomations {
      id
      name
      leaveTypeIds
      leaveTypeId
      automationType
      startDate
      calculateFrom
      endDate
      recurring
      periods {
        amount
        units
        years
      }
      isActive
      reason
      locations
      teams
      labels
      labelId
      days
      createdAt
      awardSeniorityEntitlementDaysOn
      prorate
      error
      errorCode
    }
  }
`

export const getUsersPageData = /* GraphQL */ `
  query GetUsersPageData {
    getLocationList {
      id
      name
    }
    getTeamList {
      id
      name
    }
    getLabels {
      id
      name
      color
    }
    getGoogleIntegrationSettings {
      scopes
    }
  }
`

export const getLocationsApproverTeamsAndLabels = /* GraphQL */ `
  query GetLocationsApproverTeamsAndLabels($id: String!) {
    getUser(id: $id) {
      approverToTeams {
        id
        name
        parentId
      }
    }
    getLocationListV2 {
      id
      name
      countryCode
    }
    getLabelListV2 {
      id
      name
      color
    }
  }
`

export const getApproverTeamUserLocations = /* GraphQL */ `
  query GetApproverTeamUserLocations($id: String!) {
    getUser(id: $id) {
      approverToTeams {
        id
        users {
          locationId
        }
      }
    }
  }
`

export const getAutomationFormApproverData = /* GraphQL */ `
  query GetAutomationFormApproverData($id: String!) {
    getUser(id: $id) {
      approverToTeams {
        id
        name
      }
    }
    getLocationList {
      id
      name
      countryCode
    }
    getLabels {
      id
      name
      color
    }
    getLeaveTypeList {
      id
      name
      position
      isActive
      color
    }
    getAutomations {
      id
      name
      leaveTypeIds
      leaveTypeId
      automationType
      startDate
      calculateFrom
      endDate
      recurring
      periods {
        amount
        years
        units
      }
      isActive
      reason
      locations
      teams
      labels
      labelId
      days
      createdAt
      awardSeniorityEntitlementDaysOn
      prorate
      error
      errorCode
    }
  }
`

export const getLeaveTypesListAndLocations = /* GraphQL */ `
  query GetLeaveTypesListAndLocations {
    getLocationList {
      id
      name
      countryCode
      workHours
      workWeek
    }
    getLeaveTypeList {
      id
      name
      isActive
      color
      position
      calendarStatus
      leavePolicies {
        id
        location {
          id
          name
          workHours
          workWeek
        }
        isActive
      }
      awayStatus
      awayStatusIcon
      awayStatusMessage
      deleted
      isDefault
    }
  }
`

export const getLeaveTypesList = /* GraphQL */ `
  query GetLeaveTypesList {
    getLeaveTypeList {
      id
      name
      isActive
      color
      position
      calendarStatus
      leavePolicies {
        id
        location {
          id
          name
        }
        isActive
      }
      awayStatus
      awayStatusIcon
      awayStatusMessage
      deleted
      isDefault
    }
  }
`

export const getTeamsWithApprovers = /* GraphQL */ `
  query GetTeamsWithApprovers {
    getTeamListV2 {
      id
      approvers {
        id
      }
    }
  }
`

export const getUserRoleAssignments = /* GraphQL */ `
  query GetUserRoleAssignments($id: String!) {
    getUser(id: $id) {
      id
      roleAssignments {
        roleId
        scope {
          type
          resourceIds
        }
      }
    }
  }
`

export const getUserForQuotaEdit = /* GraphQL */ `
  query GetUserForQuotaEdit($id: String!) {
    getUser(id: $id) {
      id
      name
      startDate
      location {
        id
        resetQuotas
      }
      leaveDays {
        yearStart
        yearEnd
        userWorkingHours {${getUserWorkingHoursPart()}}
        leaveTypes {
          leavePolicyId
          leaveTypeId
          leaveTypeName
          isActive
          position
          color
          accrualType
          currentDays
          earnedDays
          earnedDaysWithoutRollover
          defaultDaysPerYear
          seniorityEntitlementDaysForYear
          entitlementByRoleDaysForYear
          senioirtyEntitlementExists
          entitlementByRoleExists
          baseQuota
          quota
          toilDays
          toilDaysLapsed
          capHit
          expiredDays
          hasUnlimitedDays
          rolloverFromPreviousYear
          usedDays
          scheduledDays
          userLeaveTypeOverride
          ignoreRolloverFromPreviousYear
          allowHalfDays
          shortestLeaveInterval
          rolloverExpiryDate
          shouldProrate
          userProratedLeaveTypes
          pauseAccrualsWhenUserIsDeactivated
          ${getQuotasPart()}
        }
      }
    }
  }
`

export const getUsersLeaveSummaries = /* GraphQL */ `
  query GetUsersLeaveSummaries(
    $userIds: [String!]!
  ) {
    getUsersLeaveSummaries(userIds: $userIds) {
      summaries {
        userId
        status
        yearEnd
        leaveTypes {
          leaveTypeId
          leaveTypeName
          hasUnlimitedDays
          ${getQuotasPart()}
        }
      }
    }
  }
`

export const getLocationActiveUsersInfo = /* GraphQL */ `
  query GetLocationActiveUsersInfo($locationId: String!, $locationIds: [String!]) {
    getLocation(id: $locationId) {
      id
      name
      isDefault
    }
    getUsersFiltered(status: "ACTIVE", locationIds: $locationIds, teamIds: [], labelIds: []) {
      totalUsers
    }
  }
`

export const getUserIdsWithLabels = /* GraphQL */ `
  query GetUserIdsWithLabels($labelIds: [String!], $nextToken: String) {
    getUsersFiltered(status: "ACTIVE", locationIds: [], teamIds: [], labelIds: $labelIds, limit: 200, nextToken: $nextToken) {
      users {
        id
      }
      nextToken
    }
  }
`

export const getUsersForNotifictions = /* GraphQL */ `
  query GetUsersForNotifications($locationIds: [String!], $teamIds: [String!], $labelIds: [String!]) {
    getUsersFiltered(status: "ACTIVE", locationIds: $locationIds, teamIds: $teamIds, labelIds: $labelIds) {
      totalUsers
    }
  }
`

export const getSeniorityPreviewUser = /* GraphQL */ `
  query GetSeniorityPreviewUser($locationIds: [String!]) {
    getUsersFiltered(status: "ACTIVE", locationIds: $locationIds, limit: 200) {
      users {
        id
        name
        startDate
        location {
          id
          name
        }
      }
    }
  }
`

export const getSeniorityPreviewUserQuota = /* GraphQL */ `
  query GetSeniorityPreviewUserQuota($id: String!) {
    getUser(id: $id) {
      id
      leaveDays {
        leaveTypes {
          leaveTypeId
          quotas {
            baseQuota {
              days
              hours
            }
          }
        }
      }
    }
  }
`

export const getSeniorityPreviewLocations = /* GraphQL */ `
  query GetSeniorityPreviewLocations {
    getLocationList {
      id
      name
      resetQuotas
      yearStartMonth
      yearStartDay
    }
  }
`

export const getUsersForNotificationsWithBirthdayDate = /* GraphQL */ `
  query GetUsersForNotificationsWithBirthdayDate($locationIds: [String!], $teamIds: [String!], $labelIds: [String!]) {
    getUsersFiltered(status: "ACTIVE", locationIds: $locationIds, teamIds: $teamIds, labelIds: $labelIds) {
      totalUsers
      totalUsersWithBirthdayDate
    }
  }
`

export const getCreateTeamsData = /* GraphQL */ `
  query GetCreateTeamsData {
    getTeamList {
      id
      name
      parentId
    }
    getUsersFiltered(status: "ACTIVE", limit: 10000) {
      users {
        id
        name
      }
    }
    getAddonsSubscription {
      companyId
      addons {
        type
        status
      }
      automations {
        type
        status
      }
      integrations {
        type
        status
      }
    }
  }
`

export const getCreateLocationData = /* GraphQL */ `
  query GetCreateLocationData {
    getLeaveTypeList {
      id
      name
      isActive
    }
    getLocationList {
      id
      name
    }
    getUsersFiltered(status: "ACTIVE", limit: 10000) {
      users {
        id
        name
      }
    }
    getAddonsSubscription {
      companyId
      addons {
        type
        status
      }
      automations {
        type
        status
      }
      integrations {
        type
        status
      }
    }
  }
`

export const getSlackBotDetails = /* GraphQL */ `
  query getSlackBotDetails($id: String!) {
    slackId(id: $id) {
      slackBotId
    }
  }
`

export const getSlackDetails = /* GraphQL */ `
  query getSlackDetails($id: String!) {
    slackId(id: $id) {
      slackUserId
      slackTeamId
      slackOrgTeamId
      slackBotId
    }
  }
`

export const getScheduledReports = /* GraphQL */ `
  query getScheduledReports {
    getScheduledReportList {
      id
      name
      teams {
        id
        name
        isDefault
      }
      locations {
        id
        name
      }
      labels {
        id
        name
      }
      reportType
      period
      receivers
      timezone
      sendDayOfMonth
      sendHour
      sendMinute
      leaveStatus
      creator
      error
    }
  }
`

export const getScheduledReportById = /* GraphQL */ `
  query getScheduledReportById($id: String!) {
    getScheduledReport(id: $id) {
      id
      name
      teams {
        id
        name
      }
      locations {
        id
        name
      }
      labels {
        id
        name
      }
      reportType
      period
      receivers
      timezone
      sendDayOfMonth
      sendHour
      sendMinute
      leaveStatus
      creator
      error
    }
  }
`

export const slackIds = /* GraphQL */ `
  query SlackIds($limit: Int, $nextToken: String) {
    slackIds(limit: $limit, nextToken: $nextToken) {
      users {
        companyId
        vacationTrackerId
        slackUserId
        slackTeamId
        slackOrgTeamId
        slackBotId
        isOwner
      }
      nextToken
      scannedCount
    }
  }
`

export const getInitialBroughtForwardUnlockData = /* GraphQL */ `
  query GetInitialBroughtForwardUnlockData($locationId: String!) {
    getLocation(id: $locationId) {
      id
      name
      timestamp
      users {
        id
        name
        imageUrl
      }
      holidays {
        year
        holidays {
          name
          date
          multiDayId
          isHalfDay
        }
      }
      workWeek
      yearStartMonth
      yearStartDay
      isDefault
      firstDayOfWeek
      resetQuotas
      rolloverExpiryMonth
      rolloverExpiryDay
      rolloverExpiryAfterDays
      rolloverNeverExpireDays
      timezone
      leavePolicies {
        id
        locationId
        isActive
        daysPerYear
        hoursPerYear
        maxRolloverDays
        maxRolloverHours
        quotaSetIn
        isApprovalRequired
        hasUnlimitedDays
        allowHalfDays
        shortestLeaveInterval
        hideLeaveType
        isReasonRequired
        negativeBallanceAllowed
        accrualType
        firstEarningDate
        accrualCapRate
        accrualPeriodStart
        accrualsLocked
        enableRolloverExpiry
        rolloverExpiryMonth
        rolloverExpiryDay
        rolloverExpiryAfterDays
        toil
        toilShortestInterval
        toilRequestsAllowedForUsers
        toilExpiration
        toilExpirationDate
        toilExpirationMonths
        leaveType {
          id
          name
          isActive
          position
          deleted
        }
      }
    }
    getCompany {
      customLeaveTypes {
        leaveTypeId
        daysPerYear
        hasUnlimitedDays
      }
    }
  }
`

export const getAllLeavePolicies = /* GraphQL */ `
  query GetAllLeavePolicies {
    getLocationList {
      id
      name
      leavePolicies {
        id
        locationId
        isActive
        daysPerYear
        hoursPerYear
        hasUnlimitedDays
        isApprovalRequired
        negativeBallanceAllowed
        shortestLeaveInterval
        leaveType {
          id
          name
          color
          isActive
          deleted
        }
      }
    }
  }
`

export const getGoogleScopes = /* GraphQL */ `
  query GoogleIntegrationSettings($accessToken: String!) {
    getGoogleIntegrationSettings {
      scopes
      domainName
    }
    getGoogleTokenInfo(accessToken: $accessToken) {
      scopes
    }
  }
`

export const getUserActionFlow = /* GraphQL */ `
  query GetUserActionFlow($type: String) {
    getUserActionFlow(type: $type) {
      type
      skipped
      completed
      actions {
        ONBOARDING_CHECKLIST_BOT_VIDEO_WATCHED
        ONBOARDING_CHECKLIST_BOT_BUTTON_CLICKED
        ONBOARDING_CHECKLIST_BOT_COMPLETED
        ONBOARDING_CHECKLIST_LEAVE_REQUEST_VIDEO_WATCHED
        ONBOARDING_CHECKLIST_LEAVE_REQUEST_BUTTON_CLICKED
        ONBOARDING_CHECKLIST_LEAVE_REQUEST_COMPLETED
        ONBOARDING_CHECKLIST_ICAL_VIDEO_WATCHED
        ONBOARDING_CHECKLIST_ICAL_BUTTON_CLICKED
        ONBOARDING_CHECKLIST_ICAL_COMPLETED
        ONBOARDING_CHECKLIST_NOTIFICATIONS_VIDEO_WATCHED
        ONBOARDING_CHECKLIST_NOTIFICATIONS_BUTTON_CLICKED
        ONBOARDING_CHECKLIST_NOTIFICATIONS_COMPLETED
        ONBOARDING_CHECKLIST_IMPORT_USERS_VIDEO_WATCHED
        ONBOARDING_CHECKLIST_IMPORT_USERS_BUTTON_CLICKED
        ONBOARDING_CHECKLIST_IMPORT_USERS_COMPLETED
      }
      version
    }
  }
`

export const getUserHelpInfo = /* GraphQL */ `
  query GetUserHelpInfo {
    getUserHelpInfo {
      actions {
        HELP_INFO_LOCATION_CREATE
        HELP_INFO_LEAVE_TYPE_CREATE
      }
      version
    }
  }
`

export const getInvitations = /* GraphQL */ `
  query GetInvitations {
    getInvitations {
      id
      email
      status
      invitedBy {
        name
      }
      updatedEmail
    }
  }
`

export const getConfigureUsersData = /* GraphQL */ `
  query GetConfigureUsersData {
    getTeamList {
      id
      name
      isDefault
      parentId
    }
    getLocationList {
      id
      name
      resetQuotas
      isDefault
    }
    getLeaveTypeList {
      id
      name
      isActive
      color
      leavePolicies {
        locationId
        hasUnlimitedDays
        daysPerYear
        hoursPerYear
      }
    }
    getCompany {
      shouldImportGuestUsers
      shouldProrate
      proratedLeaveTypes
      defaultDepartmentForAutomaticImport
      defaultLocationForAutomaticImport
      announceNewUsers
    }
  }
`
export const getWhatsNew = /* GraphQL */ `
  query GetWhatsNew($limit: Int, $nextToken: String) {
    getWhatsNew(limit: $limit, nextToken: $nextToken) {
      news {
        messageId
        title
        description
        imageUrl
        unread
        linkText
        linkUrl
        timestamp
        videoEmbedId
        showPopup
        subtitle
        openLinkInSameTab
      }
      nextToken
    }
  }
`

export const getLeaveTypeListShort = /* GraphQL */ `
  query GetLeaveTypeListShort {
    getLeaveTypeList {
      id
      name
      position
      color
    }
  }
`

export const getWizardDepartmentData = /* GraphQL */ `
  query GetWizardDepartmentData {
    getTeamList {
      id
      name
      isDefault
    }
  }
`

export const getWizardLeaveTypeData = /* GraphQL */ `
  query GetWizardLeaveTypeData($locationId: String!) {
    getLeaveTypeList {
      id
      name
      isActive
      color
      isDefault
    }
    getLocation(id: $locationId) {
      id
      leavePolicies {
        id
        daysPerYear
        hasUnlimitedDays
        isApprovalRequired
        allowHalfDays
        shortestLeaveInterval
        leaveType {
          id
        }
      }
    }
  }
`

export const getAddonsSubscription = /* GraphQL */ `
  query GetAddonsSubscription {
    getAddonsSubscription {
      companyId
      addons {
        type
        status
      }
      automations {
        type
        status
      }
      integrations {
        type
        status
      }
    }
  }
`

export const getPurchasedAddons = /* GraphQL */ `
  query GetPurchasedAddons {
    getPurchasedAddons {
      companyId
      addons {
        type
        status
      }
      automations {
        type
        status
      }
      integrations {
        type
        status
      }
    }
  }
`

/**
 * ------------------AUTOMATIONS START-------------------------------------
 * Automations are outdated and is kept for avoiding breaking changes
 * All opf them are considered as add-ons with different types (Automations, Integrations, Add-ons)
 * AutomationsViewTable is storing automations, add-ons and integrations
 * --------------------------------------------------------------
 */

export const getAutomations = /* GraphQL */ `
  query getAutomations {
    getAutomations {
      id
      name
      leaveTypeIds
      leaveTypeId
      automationType
      startDate
      calculateFrom
      endDate
      recurring
      period
      periods {
        amount
        years
        units
      }
      maxUsersAway {
        type
        value
      }
      autoRejectResponse
      isActive
      reason
      locations
      teams
      labels
      labelId
      days
      createdAt
      awardSeniorityEntitlementDaysOn
      prorate
      error
      errorCode
      visibilityLevel
      lengthDays
      owner {
        id
        name
      }
      currentMonthUsage
      apiKeyValue
      amount
      units
      minimumDuration
      maximumDuration
      minLeaveDurationForAdvanceNotice
      requiredAdvanceNoticeDays
    }
  }
`

export const getAutomationsById = /* GraphQL */ `
  query GetAutomationsById($id: String!) {
    getAutomation(id: $id) {
      id
      name
      leaveTypeId
      leaveTypeIds
      automationType
      startDate
      calculateFrom
      endDate
      recurring
      isActive
      reason
      period
      periods {
        amount
        years
        units
      }
      maxUsersAway {
        type
        value
      }
      autoRejectResponse
      prorate
      locations
      locationIds
      teams
      teamIds
      labels
      labelId
      labelIds
      owner {
        id
        name
      }
      days
      awardSeniorityEntitlementDaysOn
      lengthDays
      amount
      units
      minimumDuration
      maximumDuration
      minLeaveDurationForAdvanceNotice
      requiredAdvanceNoticeDays
    }
  }
`

export const getSeniorityEntitlementAddedDays = /* GraphQL */ `
  query GetSeniorityEntitlementAddedDays($automationId: String!, $limit: Int!) {
    getUsersSeniorityEntitlementAddedDays(automationId: $automationId, limit: $limit) {
      totalUsers
      users {
        id
        amount
        units
      }
    }
  }
`

/**
 * ------------------AUTOMATIONS END-------------------------------------
 * Automations are outdated and is kept for avoiding breaking changes
 * All opf them are considered as add-ons with different types (Automations, Integrations, Add-ons)
 * AutomationsViewTable is storing automations, add-ons and integrations
 * --------------------------------------------------------------
 */

export const getUserName = /* GraphQL */ `
  query GetUserName($userId: String!) {
    getUser(id: $userId) {
      name
    }
  }
`

export const entitlementByRoleData = /* GraphQL */ `
  query EntitlementByRoleData {
    getLabels {
      id
      name
      color
    }
    getLeaveTypeList {
      id
      name
      position
    }
  }
`

export const getOverlappingUsersInfo = /* GraphQL */ `
  query GetOverlappingUsersInfo($teamId: String!, $leaveRequest: BasicLeaveRequestInfo) {
    getOverlappingUsersInfo(teamId: $teamId, leaveRequest: $leaveRequest) {
      message
      employees
      calendarDays
      workingDays
      workingHours
      leaveDaysList
      leaveDaysWithWorkingHours {
        day
        leaveHours
        workingHoursInDay
      }
      year1Days
      year2Days
      daysOnLeaveEndDates
      hoursOnLeaveEndDates
      userWorkingHours {${getUserWorkingHoursPart()}}
      nextYearStart
    }
  }
`

export const getCalendars = /* GraphQL */ `
  query getCalendars($companyId: String!) {
    getCalendars(companyId: $companyId) {
      type
      id
      refreshToken
      accessToken
      locationId
      locationIds
      labelIds
      teamIds
      labelId
      teamId
      creator
      errors
    }
  }
`

export const getSharedCalendarTypes = /* GraphQL */ `
  query getSharedCalendarTypes($companyId: String!) {
    getCalendars(companyId: $companyId) {
      type
      deleted
    }
  }
`

export const getSyncedCalendarsData = /* GraphQL */ `
  query getSyncedCalendarsData($companyId: String!) {
    getCalendars(companyId: $companyId) {
      type
      id
      locationId
      locationIds
      labelIds
      teamIds
      labelId
      teamId
      tenant
      creator
      timezone
      errors {
        code
        message
      }
      error {
        code
        message
      }
      creator
      calendarName
      user {
        id
        name
      }
      deleted
      pushPublicHolidays
    }
    getLocationListV2 {
      id
      name
    }
    getTeamListV2 {
      id
      name
      parentId
    }
    getLabelListV2 {
      id
      name
      color
    }
  }
`
export const getTeamsForApprover = /* GraphQL */ `
  query getTeamsForApprover($id: String!, $date: String) {
    getUser(id: $id) {
      approverToTeams {
        id
        name
        approvers {
          id
          name
          approverLevels
          upcomingLeaves(date: $date) {
            id
            status
            user {
              id
            }
            approver {
              id
              name
            }
            leaveType {
              name
            }
            startDate
            endDate
          }
        }
      }
      teamId
    }
  }
`

export const getConsumedLeaveRequestsForPeriod = /* GraphQL */ `
  query GetConsumedLeaveRequestsForPeriod($dateStart: String!, $dateEnd: String!) {
    getConsumedLeaveRequestsForPeriod(dateStart: $dateStart, dateEnd: $dateEnd) {
      userId
      leaves {
        date
        hours
        isPartDay
      }
    }
  }
`

export const getConsumedToilRequestsForPeriod = /* GraphQL */ `
  query GetConsumedToilRequestsForPeriod($dateStart: String!, $dateEnd: String!) {
    getConsumedToilRequestsForPeriod(dateStart: $dateStart, dateEnd: $dateEnd) {
      userId
      leaveTypes {
        id
        days
      }
    }
  }
`

const childrenFragment = /* GraphQL */ `
  fragment Children on TeamTree {
    id
    name
    isDefault
    timestamp
    users {
      id
      name
      imageUrl
    }
    approvers {
      id
      name
      imageUrl
    }
    children {
      id
      name
      isDefault
      timestamp
      users {
        id
        name
        imageUrl
      }
      approvers {
        id
        name
        imageUrl
      }
      children {
        id
        name
        isDefault
        timestamp
        users {
          id
          name
          imageUrl
        }
        approvers {
          id
          name
          imageUrl
        }
      }
    }
  }
`

const childrenFragmentComplete = /* GraphQL */ `
  fragment ChildrenComplete on TeamTree {
    id
    name
    isDefault
    timestamp
    users {
      id
      name
      imageUrl
    }
    approvers {
      id
      name
      imageUrl
    }
    children {
      id
      name
      isDefault
      timestamp
      users {
        id
        name
        imageUrl
      }
      approvers {
        id
        name
        imageUrl
      }
      children {
        id
        name
        isDefault
        timestamp
        users {
          id
          name
          imageUrl
        }
        approvers {
          id
          name
          imageUrl
        }
        children {
          id
          name
          isDefault
          timestamp
          users {
            id
            name
            imageUrl
          }
          approvers {
            id
            name
            imageUrl
          }
          children {
            id
            name
            isDefault
            timestamp
            users {
              id
              name
              imageUrl
            }
            approvers {
              id
              name
              imageUrl
            }
            children {
              id
              name
              isDefault
              timestamp
              users {
                id
                name
                imageUrl
              }
              approvers {
                id
                name
                imageUrl
              }
            }
          }
        }
      }
    }
  }
`

export const getTeamTree = /* GraphQL */ `
  ${childrenFragment}
  query GetTeamTree {
    getTeamTree {
      id
      name
      isDefault
      timestamp
      users {
        id
        name
        imageUrl
      }
      approvers {
        id
        name
        imageUrl
      }
      ...Children
    }
  }
`
export const getTeamTreeComplete = /* GraphQL */ `
  ${childrenFragmentComplete}
  query GetTeamTreeComplete {
    getTeamTree {
      id
      name
      isDefault
      timestamp
      users {
        id
        name
        imageUrl
      }
      approvers {
        id
        name
        imageUrl
      }
      ...ChildrenComplete
    }
  }
`

export const getAiAssistedOnboardingData = /* GraphQL */ `
  query getAiAssistedOnboardingData {
    getTeamList {
      id
      name
      isDefault
    }
    getLocationList {
      id
      name
      resetQuotas
      timestamp
      timezone
      yearStartDay
      yearStartMonth
      firstDayOfWeek
    }
    getLeaveTypeList {
      id
      name
      isActive
      deleted
      color
      position
      isDefault
    }
  }
`

export const getAiAssistantConversationInfoData = /* GraphQL */ `
  query getAiAssistantConversationInfo($companyId: String!) {
    getAiAssistedConversationInfo(companyId: $companyId) {
      topic
      timestamp
      isDone
      updatedAt
      id
    }
  }
`

export const getAiAssistantConversationInfoAndMessagesData = /* GraphQL */ `
  query getAiAssistantConversationInfoAndMessages($companyId: String!, $userId: String!, $conversationId: String!) {
    getAiAssistedConversationInfoAndMessages(companyId: $companyId, userId: $userId, conversationId: $conversationId) {
      role
      content
      companyId
      userId
      id
      timestamp
      userId
      ttl
      isDone
      topic
      type
    }
  }
`

export const getAiAssistedOnboardingSetupCoreEventsData = /* GraphQL */ `
  query getAiAssistedOnboardingSetupCoreEvents($companyId: String!) {
    getAiAssistedOnboardingSetupCoreEvents(companyId: $companyId) {
      setupJSON
      eventType
      eventGroup
      name
      id
      leaveTypeId
      locationId
      teamId
      status
    }
  }
`
export const getExportFilters = /* GraphQL */ `
  query GetExportFilters {
    getLocationList {
      id
      name
      countryCode
    }
    getTeamList {
      id
      name
      parentId
    }
    getLeaveTypeList {
      id
      name
      position
      color
    }
    getLabels {
      id
      name
    }
    getUsersFiltered(status: "ACTIVE", limit: 10000) {
      users {
        id
        name
      }
    }
  }
`

export const getUsersFilteredByStatus = /* GraphQL */ `
  query GetUsersFilteredByStatus($status: String!) {
    getUsersFiltered(status: $status, limit: 10000) {
      users {
        id
        name
      }
    }
  }
`

export const getLeaveRequestReport = /* GraphQL */ `
  query GetLeaveRequestReport(
    $startDate: String!
    $endDate: String!
    $statuses: [String] = []
    $userIds: [String] = []
    $userStatuses: [String] = []
    $locationIds: [String] = []
    $departmentIds: [String] = []
    $leaveTypeIds: [String] = []
    $labelIds: [String] = []
    $requestTypes: [String] = []
    $limit: Int
    $lastId: String = ""
  ) {
    getLeaveRequestReport(
      startDate: $startDate
      endDate: $endDate
      statuses: $statuses
      userStatuses: $userStatuses
      userIds: $userIds
      locationIds: $locationIds
      departmentIds: $departmentIds
      leaveTypeIds: $leaveTypeIds
      labelIds: $labelIds
      requestTypes: $requestTypes
      limit: $limit
      lastId: $lastId
    ) {
        total
        data {
          id
          startDate
          endDate
          isFullDay
          startHour
          endHour
          startMinute
          endMinute
          user
          userId
          approver
          approverId
          email
          employeeId
          reason
          status
          requestType
          duration {${getQuotaFieldsPart()}}
          leaveType
          location
          department
          labels
        }
      }
    }
`

export const getLeaveBalanceReport = /* GraphQL */ `
  query GetLeaveBalanceReport(
    $period: String
    $startDate: String = ""
    $endDate: String = ""
    $userIds: [String] = []
    $userStatuses: [String] = []
    $locationIds: [String] = []
    $departmentIds: [String] = []
    $leaveTypeIds: [String] = []
    $labelIds: [String] = []
    $limit: Int
    $lastId: String = ""
  ) {
    getLeaveBalanceReport(
      period: $period
      startDate: $startDate
      endDate: $endDate
      userIds: $userIds
      userStatuses: $userStatuses
      locationIds: $locationIds
      departmentIds: $departmentIds
      leaveTypeIds: $leaveTypeIds
      labelIds: $labelIds
      limit: $limit
      lastId: $lastId
    ) {
        total
        data {
          id
          user
          userId
          email
          employeeId
          leaveType
          location
          department
          labels
          broughtForward {${getQuotaFieldsPart()}}
          yearlyQuota {${getQuotaFieldsPart()}}
          yearlyQuotaBase {${getQuotaFieldsPart()}}
          yearlyQuotaSeniority {${getQuotaFieldsPart()}}
          yearlyQuotaRoleBased {${getQuotaFieldsPart()}}
          accruedAmount {${getQuotaFieldsPart()}}
          expiredBroughtForward {${getQuotaFieldsPart()}}
          usedAmount {${getQuotaFieldsPart()}}
          scheduledAmount {${getQuotaFieldsPart()}}
          remainingAmount {${getQuotaFieldsPart()}}
          toil {${getQuotaFieldsPart()}}
          toilExpired {${getQuotaFieldsPart()}}
        }
      }
    }
`

export const getLeaveBalanceMonthlyReport = /* GraphQL */ `
  query GetLeaveBalanceMonthlyReport(
    $userIds: [String] = []
    $userStatuses: [String] = []
    $locationIds: [String] = []
    $departmentIds: [String] = []
    $leaveTypeIds: [String] = []
    $labelIds: [String] = []
    $limit: Int
    $lastId: String = ""
  ) {
    getLeaveBalanceMonthlyReport(
      userIds: $userIds
      userStatuses: $userStatuses
      locationIds: $locationIds
      departmentIds: $departmentIds
      leaveTypeIds: $leaveTypeIds
      labelIds: $labelIds
      limit: $limit
      lastId: $lastId
    ) {
      total
      data {
        id
        user
        userId
        email
        employeeId
        leaveType
        location
        department
        labels
        amount {
          month
          year
          raw {
            days
            hours
          }
        }
      }
    }
  }
`

export const getDepartmentsAndLocations = /* GraphQL */ `
  query getDepartmentsAndLocations {
    getTeamList {
      id
      name
      isDefault
    }
    getLocationList {
      id
      name
      isDefault
    }
  }
`

export const getLeaveRequestDetails = /* GraphQL */ `
  query GetLeaveRequestDetails($id: String!) {
    getLeaveRequestDetails(id: $id) {
      eventType
      timestamp
      creatorId
      creatorName
      creatorImageUrl
      startDate
      endDate
      partDayStartHour
      partDayEndHour
      isReasonChanged
      oldStartDate
      oldEndDate
      oldPartDayStartHour
      oldPartDayEndHour
      isMultiLevelApproval
      integrationName
    }
  }
`

export const getLeaveRequestListDetails = /* GraphQL */ `
  query GetLeaveRequestListDetails($userId: String!) {
    getLeaveRequestListDetails(userId: $userId) {
      id
      events {
        eventType
        timestamp
        creatorId
        creatorName
        creatorImageUrl
        startDate
        endDate
        partDayStartHour
        partDayEndHour
        isReasonChanged
        oldStartDate
        oldEndDate
        oldPartDayStartHour
        oldPartDayEndHour
        isMultiLevelApproval
        integrationName
      }
    }
  }
`

export const trialSurveyQuestions = /* GraphQL */ `
  query TrialSurveyQuestions($surveyName: String) {
    trialSurveyQuestions(surveyName: $surveyName) {
      id
      type
      labelKey
      order
      required
      showIf {
        questionId
        equals
        equalsValue
      }
      options {
        value
        labelKey
        allowText
      }
      surveyVersion
    }
  }
`

export const getWebAgentConversationsPaginatedData = /* GraphQL */ `
  query getWebAgentConversationsPaginated($limit: Int, $nextToken: String) {
    getWebAgentConversationsPaginated(limit: $limit, nextToken: $nextToken) {
      conversations {
        id
        topic
        timestamp
        updatedAt
        badge
      }
      nextToken
    }
  }
`

export const getWebAgentConversationMessagesData = /* GraphQL */ `
  query getWebAgentConversationMessages($conversationId: String!) {
    getWebAgentConversationMessages(conversationId: $conversationId) {
      id
      role
      content
      timestamp
      type
      metadata
    }
  }
`
